import React from 'react';

import {
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';

import Tooltip from '../../../commonComponents/Tooltip';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import DropDownMenu from '../../../commonComponents/DropDownMenu';
import RequiredMark from '../../../commonComponents/RequiredMark';

import custJqAjax from '../../../commonJS/custJqAjax';
import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';


export default class SpecItemDetailCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      textAreaOnChange: e => {
        const jsInp = e.currentTarget,
          id = jsInp.id,
          value = jsInp.value;

        this.setState({
          [id]: value
        });
      },
      onChange: (selection, id, cb) => {
        const value = selection.value;

        this.setState({
          [id]: value
        });

      },
      onInputFocus: e => {
        autoFill(e, this);
      },
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onSortUpdate: (newSort, cb) => {
        // 最後一筆刪除後不需更新
        if (this.props.solutionNum < 2) {
          if (cb) cb();
          return;
        }

        const arrObj = this.props.arrSolutionsObj;

        let fd = new FormData(), sortArr = [],
          oldSort = this.props.solutionSort * 1;
        fd.append('model_id', this.props.productId);

        // 產生預設排序
        for (let i = 0; i < this.props.solutionNum; i++) {
          sortArr[i] = arrObj[i].item_id;
        }

        sortArr.splice(oldSort - 1, 1); // 移除舊位置

        if (newSort) {
          newSort *= 1; // 確保為數字
          sortArr.splice(newSort - 1, 0, arrObj[oldSort - 1].item_id); // 移至新位置
        }

        fd.append('item_id_list', sortArr);

        custJqAjax({
          type: 'POST',
          url: '/api/W_SaleSky_Product_Group_Item_Lang_Sort_Update.php',
          data: fd,
          processData: false,
          contentType: false,
          success: res => {
            if (cb) cb();
          }
        });
      },
      onSaveClick: isUpdate => {
        // 每次點issue treeview都會call api更新，所以不用去更新其既存資料

        let formData = new FormData(),
          sortState = this.state.sort,
          id = isUpdate ? this.props.solutionId : "",
          sortTemp = 0,
          item_name_list = `${this.state.solutionName_tw}|${this.state.solutionName_en}|${this.state.solutionName_cn}|${this.state.solutionName_ja}`;
        formData.append('model_id', this.props.productId);
        formData.append('item_name_list', item_name_list);

        if (!isUpdate) {
          sortState = this.props.solutionNum + 1;

          if (sortState !== this.state.sort) sortTemp = this.state.sort;

        } else formData.append('item_id', id);

        formData.append('sort', sortState);


        // sort有變動之處理，若有變動，先執行sort update再執行step update
        // 預設p1為既時完成promise，sort有變時再替換為一般promise
        let p1 = new Promise((resolve, reject) => { resolve(); });

        if (isUpdate && (this.props.solutionSort.toString() !== this.state.sort.toString())) {
          p1 = new Promise((resolve, reject) => { this.handlers.onSortUpdate(this.state.sort, resolve); });
        }


        p1.then(value => {

          custJqAjax({
            type: 'POST',
            url: `/api/W_SaleSky_ProductGroupItem_${isUpdate ? 'Update' : 'Post'}.php`,
            data: formData,
            processData: false,
            contentType: false,
            success: res => {
              let states = ['activeSolutionId', 'activeSolutionSort', 'solutionModMode'],
                newValues = [res.result.item_id, this.state.sort, 'edit'];

              const tempObj = {
                solution_id: res.result.item_id,
                name_tw: this.state.solutionName_tw,
                name_en: this.state.solutionName_en,
                name_cn: this.state.solutionName_cn,
                name_ja: this.state.solutionName_ja,
                sort: this.state.sort
              };

              states.push('activeSolution');
              newValues.push(tempObj);

              // 新增solution時清空既存steplist
              if (!isUpdate) {
                states.push('arrStepsObj', 'solutionSteps', 'activeStepSort', 'stepModMode');
                newValues.push([], [], 0, '');
              }


              // if(!isUpdate) {
              //   // 觸發更新treeview物件
              //   states.push('addSolution');
              //   newValues.push(true);
              //   // 新增第一筆時更新treeview的刪除鈕狀態
              //   if(sortState * 1 === 1) {
              //     states.push('doIssueCategoryRefresh');
              //     newValues.push(true);
              //   }
              // }


              const p = new Promise((resolve, reject) => {
                this.props.refreshSolutionData(this.props.productId, resolve);
              });

              this.props.parentStateHandler({ states, newValues });

              p.then(result => {
                // this.props.parentStateHandler({states, newValues});

                // 如果為新增且同時改變預設排序時，以預設sort新增後
                // 再用指定sort執行一次update
                if (sortTemp !== 0) {
                  this.props.parentStateHandler({ states: 'activeSolutionSort', newValues: this.props.solutionNum });

                  this.setState({ sort: sortTemp }, () => {
                    this.handlers.onSaveClick(1);
                  });
                }

              }).catch(error => { });

              this.setState({ editMode: 'View', onEdit: false });
            }
          });

        }).catch(error => { });
      },
      onDeleteClick: () => {

        let formData = new FormData();

        formData.append('model_id', this.props.productId);

        formData.append('item_id', this.props.solutionId);

        custJqAjax({
          type: 'POST',
          url: `/api/W_SaleSky_ProductGroupItem_Delete.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            let states = ['activeSolutionId', 'activeSolutionSort', 'solutionModMode', 'arrStepsObj', 'solutionSteps', 'activeSolution'],
              newValues = ['', '', '', [], [], {}];
            // // 觸發更新treeview物件
            // states.push('delSolution');
            // newValues.push(true);
            // // 刪除最後一筆時更新treeview的刪除鈕狀態
            // if(this.props.solutionNum === 1) {
            //   states.push('doIssueCategoryRefresh');
            //   newValues.push(true);
            // }

            // 先重新排序，再更新step data
            const p = new Promise((resolve, reject) => {
              this.handlers.onSortUpdate('', resolve);
            });

            p.then(value => {
              this.props.refreshSolutionData(this.props.productId);
              this.props.parentStateHandler({ states, newValues });
            }).catch(error => { });

            this.setState({ editMode: 'View', onEdit: false });
          }
        });
      }
    }

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // funcs
    this.funcs = {
      optsSortGen: len => {
        len++;
        let arr = [];
        for (let i = 1; i < len; i++) {
          arr.push({ value: i, label: i });
        }

        return arr;
      },
      initialFormData: () => {
        // 產生排序選項
        let sort, optsSort;

        switch (this.props.solutionModMode) {
          case 'create':
            sort = this.props.solutionNum + 1;
            optsSort = this.funcs.optsSortGen(sort);
            break;
          case 'edit':
            sort = this.props.solutionSort * 1;
            // 新增後因為solutions要等ajax完成後才會更新，所以
            // this.props.solutionNum會少1，直接以此判斷比控制順序簡單
            optsSort = this.funcs.optsSortGen(((sort - this.props.solutionNum) > 0) ? sort : this.props.solutionNum);
            break;
          default:
        }

        this.setState({
          sort,
          optsSort,
          solutionName_tw: this.props.activeSolution.name_tw || '',
          solutionName_en: this.props.activeSolution.name_en || '',
          solutionName_cn: this.props.activeSolution.name_cn || '',
          solutionName_ja: this.props.activeSolution.name_ja || ''
        });
      }
    };


    this.state = {
      // form
      sort: 0,
      optsSort: [],
      solutionName_tw: '',
      solutionName_en: '',
      solutionName_cn: '',
      solutionName_ja: '',
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View",
      editPermission: true
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.solutionName_tw === '' || this.state.solutionName_en === '' || this.state.solutionName_cn === '') {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) this.setState({ btnSaveDisable: false });

    if (
      (this.props.solutionId !== prevProps.solutionId) ||
      (this.props.solutionModMode !== prevProps.solutionModMode)
      // (this.props.solutionNum !== prevProps.solutionNum)
    ) {
      this.funcs.initialFormData();
    }

    if (this.props.solutionModMode === 'create' && prevProps.solutionModMode !== 'create') {
      document.getElementById('solutionName_tw').focus();
    }

  }

  render() {

    let saveBtn = "",
      deleteBtn = "",
      editable = 0,
      modeBtns = "";


    if (this.state.editMode !== "View" || !this.props.solutionId) {
      saveBtn = (
        <Button className='btn-next-to-title' disabled={this.state.btnSaveDisable}
          onClick={() => { this.handlers.onSaveClick(this.props.solutionModMode === 'edit' ? 1 : 0) }}>
          儲存
        </Button>
      );
      editable = 1;
    } else {
      const permission = this.state.editPermission;
      let tipText = "";

      // if(!permission) {
      //   if(this.props.userId !== this.state.calendarOwnerId) tipText = "Only the creater is allowed to edit.";
      // else tipText = "You are allowed to edit logs which are created today";
      // }

      modeBtns = (
        <span>
          {/*<Button 
            onClick={this.handlers.onCopyClick}
            className='btn-next-to-title'>
            複製
          </Button>*/}
          <Button
            disabled={!permission}
            onClick={this.handlers.onEditClick}
            className='btn-next-to-title'>
            編輯
            {permission ? "" : <Tooltip tipText={tipText} placement="left" />}
          </Button>
        </span>
      );

    }

    deleteBtn = (this.state.onEdit && this.props.solutionModMode === 'edit') ?
      <DeleteBtnWithConfirm
        className='btn-next-to-title'
        onClick={this.handlers.onDeleteClick}
        title="Are you sure?" />
      : "";

    // key part area

    return (
      <Col sm={9}>
        <Row>
          <Col sm={12}>
            <div style={{ fontWeight: "bold", position: 'relative' }}>
              分類內容維護
              <div className='div-modify-btns-container'>
                {saveBtn}
                {modeBtns}
                {deleteBtn}
              </div>
            </div>
          </Col>
        </Row>
        <Well style={{ minHeight: 344 }}>
          {
            (this.props.solutionModMode) ?
              <div>
                <Row>
                  <Col sm={12}>
                    <div style={{ fontWeight: "bold" }}><RequiredMark />分類名稱</div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <Well>

                      <Row>
                        <Col sm={6}>
                          <FormGroup controlId="solutionName_tw"
                            validationState={this.state.solutionName_tw ? null : 'error'}>

                            <ControlLabel>繁體中文</ControlLabel>
                            <FormControl
                              onFocus={this.handlers.onInputFocus}
                              autoFocus={true}
                              disabled={!editable}
                              type='text'
                              onChange={this.handlers.textAreaOnChange}
                              value={this.state.solutionName_tw} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="solutionName_en"
                            validationState={this.state.solutionName_en ? null : 'error'}>

                            <ControlLabel>英文</ControlLabel>
                            <FormControl
                              onFocus={this.handlers.onInputFocus}
                              disabled={!editable}
                              onChange={this.handlers.textAreaOnChange}
                              type='text'
                              value={this.state.solutionName_en} />
                          </FormGroup>
                        </Col>

                        <Col sm={6}>
                          <FormGroup controlId="solutionName_cn"
                            validationState={this.state.solutionName_cn ? null : 'error'}>

                            <ControlLabel>簡體中文</ControlLabel>
                            <FormControl
                              onFocus={this.handlers.onInputFocus}
                              disabled={!editable}
                              type='text'
                              onChange={this.handlers.textAreaOnChange}
                              value={this.state.solutionName_cn} />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup controlId="solutionName_ja">
                            <ControlLabel>日文</ControlLabel>
                            <FormControl
                              onFocus={this.handlers.onInputFocus}
                              disabled={!editable}
                              onChange={this.handlers.textAreaOnChange}
                              type='text'
                              value={this.state.solutionName_ja} />
                          </FormGroup>
                        </Col>

                      </Row>

                    </Well>
                  </Col>
                </Row>

                <Row>

                  <DropDownMenu
                    sm={12}
                    disabled={!editable}
                    required={false}
                    label="排序位置"
                    value={this.state.sort}
                    stateName="sort"
                    onChange={this.handlers.onChange}
                    options={this.state.optsSort} />

                </Row>
              </div>
              : ""
          }


        </Well>
      </Col>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/SpecItemDetailCt.jsx